module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-hide-in-form": true,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true
    }
  }, _vm.$listeners), [_c('label', [_vm._v("Values")]), _vm._v(" "), _c('vue-form-editor', {
    key: 'accordion-editor',
    attrs: {
      "schema": _vm.item.values,
      "shared-fields": _vm.sharedFields,
      "id": _vm.id
    },
    on: {
      "add": _vm.clear,
      "field-removed": function($event) {
        return _vm.$emit('field-removed', $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cb08498","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorAccordion.vue
// module id = 1593
// module chunks = 1